import * as ServerTypes from '@wix/ambassador-restaurants-menu-settings-v1-menu-ordering-settings/types';
import * as ClientTypes from '../../models/menu-ordering-settings';
import { WeeklyAvailabilityConverter } from '../fulfillment/availability-converter';
import { DateTimeConverter } from '../date-time-converter';
import { getClientTimezoneOffsetHours } from '../../minutes-range/timeUtils';
const availabilityTypeMap = {
  [ServerTypes.AvailabilityType.UNSPECIFIED_AVAILABILITY_OPTION]: ClientTypes.AvailabilityType.ALWAYS_AVAILABLE,
  [ServerTypes.AvailabilityType.ALWAYS_AVAILABLE]: ClientTypes.AvailabilityType.ALWAYS_AVAILABLE,
  [ServerTypes.AvailabilityType.WEEKLY_SCHEDULE]: ClientTypes.AvailabilityType.WEEKLY_SCHEDULE,
  [ServerTypes.AvailabilityType.TIMESTAMP_RANGES]: ClientTypes.AvailabilityType.TIMESTAMP_RANGES,
  [ClientTypes.AvailabilityType.ALWAYS_AVAILABLE]: ServerTypes.AvailabilityType.ALWAYS_AVAILABLE,
  [ClientTypes.AvailabilityType.WEEKLY_SCHEDULE]: ServerTypes.AvailabilityType.WEEKLY_SCHEDULE,
  [ClientTypes.AvailabilityType.TIMESTAMP_RANGES]: ServerTypes.AvailabilityType.TIMESTAMP_RANGES
};
export const MenuOrderingSettingsConverter = {
  toServerModel: (clientSetting, restaurantTimezoneOffset) => {
    DateTimeConverter.validateTimezoneOffset(restaurantTimezoneOffset);
    const clientTimezoneOffset = getClientTimezoneOffsetHours();
    const availabilityType = availabilityTypeMap[clientSetting.availability.type];
    const isWeeklyScheduleAvailability = availabilityType === ServerTypes.AvailabilityType.WEEKLY_SCHEDULE;
    const isTimestampRangesAvailability = availabilityType === ServerTypes.AvailabilityType.TIMESTAMP_RANGES;
    return {
      id: clientSetting.id ?? undefined,
      revision: clientSetting.revision ?? undefined,
      operationId: clientSetting.operationId,
      menuId: clientSetting.menuId ?? undefined,
      onlineOrderingEnabled: clientSetting.onlineOrderingEnabled ?? true,
      availability: {
        type: availabilityType,
        timestampRangesOptions: isTimestampRangesAvailability ? {
          ranges: clientSetting.availability.timestampRangesOptions.ranges.map(range => {
            const {
              startTime: clientStartTime,
              endTime: clientEndTime
            } = range;
            let startTime = new Date(clientStartTime);
            startTime.setHours(0, 0, 0, 0);
            let endTime = new Date(clientEndTime);
            endTime.setHours(23, 59, 59, 0);
            startTime = DateTimeConverter.fromRestaurantDate(startTime, restaurantTimezoneOffset, clientTimezoneOffset);
            endTime = DateTimeConverter.fromRestaurantDate(endTime, restaurantTimezoneOffset, clientTimezoneOffset);
            return {
              startTime,
              endTime
            };
          })
        } : undefined,
        weeklyScheduleOptions: isWeeklyScheduleAvailability ? {
          availableTimes: WeeklyAvailabilityConverter.toServerModel(clientSetting.availability.weeklyScheduleOptions.weeklyAvailability)
        } : undefined
      },
      createdDate: clientSetting.createdDate,
      updatedDate: clientSetting.updatedDate,
      businessLocationId: clientSetting.businessLocationId
    };
  },
  fromServerModel: function (serverSettings, restaurantTimezoneOffset, resetTimestampRangesTime) {
    var _serverSettings$avail, _serverSettings$avail2, _serverSettings$avail3;
    if (resetTimestampRangesTime === void 0) {
      resetTimestampRangesTime = true;
    }
    DateTimeConverter.validateTimezoneOffset(restaurantTimezoneOffset);
    const clientTimezoneOffset = getClientTimezoneOffsetHours();
    return {
      id: serverSettings.id ?? undefined,
      revision: serverSettings.revision ?? undefined,
      operationId: serverSettings.operationId,
      menuId: serverSettings.menuId ?? undefined,
      onlineOrderingEnabled: serverSettings.onlineOrderingEnabled ?? true,
      availability: {
        type: availabilityTypeMap[((_serverSettings$avail = serverSettings.availability) == null ? void 0 : _serverSettings$avail.type) ?? ServerTypes.AvailabilityType.ALWAYS_AVAILABLE],
        timestampRangesOptions: (_serverSettings$avail2 = serverSettings.availability) != null && _serverSettings$avail2.timestampRangesOptions ? {
          ranges: serverSettings.availability.timestampRangesOptions.ranges.map(range => {
            const {
              startTime: serverStartTime,
              endTime: serverEndTime
            } = range;
            const startTime = DateTimeConverter.toRestaurantDate(serverStartTime, restaurantTimezoneOffset, clientTimezoneOffset);
            const endTime = DateTimeConverter.toRestaurantDate(serverEndTime, restaurantTimezoneOffset, clientTimezoneOffset);
            if (resetTimestampRangesTime) {
              startTime.setHours(0, 0, 0, 0);
              endTime.setHours(0, 0, 0, 0);
            }
            return {
              startTime,
              endTime
            };
          })
        } : undefined,
        weeklyScheduleOptions: (_serverSettings$avail3 = serverSettings.availability) != null && _serverSettings$avail3.weeklyScheduleOptions ? {
          weeklyAvailability: WeeklyAvailabilityConverter.fromServerModel(serverSettings.availability.weeklyScheduleOptions)
        } : undefined
      },
      createdDate: serverSettings.createdDate,
      updatedDate: serverSettings.updatedDate,
      businessLocationId: serverSettings.businessLocationId ?? undefined
    };
  }
};
//# sourceMappingURL=menu-ordering-settings-converter.js.map